import React, { Component } from 'react';
import Link from 'gatsby-link';
import styled from 'styled-components';
import {
  Icon,
  Address,
  Email,
  SocialIcons,
  TeamImage,
  SplitSection,
  LeftSection,
  RightSection
} from '../../static/styles/styles';
import Navigation from '../../componenten/Navigation';
import HulpiaArchitectenComp from '../../componenten/HulpiaArchitectenComp';
import hulpiaMap from '../../static/img/kaart.png';
import facebook from '../../static/img/facebook.jpg';
import instagram from '../../static/img/instagram.png';

const Sticky = styled.div`
  position: sticky;
  background-color: #fff;
  top: 160px;
  z-index: 3;
`;

class InfoPage extends Component {
  render() {
    const navItems = this.props.data.allNavigationJson.edges;
    const subNavContact = navItems.filter(
      ({ node: navItem }, index) => index === 1
    );

    return (
      <div>
        <Sticky>
          <Navigation items={subNavContact} navType="sub" />
        </Sticky>
        <SplitSection>
          <LeftSection>
            <HulpiaArchitectenComp />
          </LeftSection>
          <RightSection>
            <Address>
              <div>Rabotstraat 63 - 9940 Evergem</div>
              <Email href={`mailto:info@hulpia.be`}>info@hulpia.be</Email>
              <div>+32 9 253 55 73</div>
            </Address>
            <a
              target="_blank"
              href="https://www.google.be/maps/place/Rabotstraat+63,+9940+Evergem/@51.0960153,3.6534602,17z/data=!3m1!4b1!4m5!3m4!1s0x47c370237e82d07d:0xd04bf4d51450c2d!8m2!3d51.096015!4d3.655654?hl=nl"
            >
              <TeamImage src={hulpiaMap} alt="" />
            </a>
            <SocialIcons>
              <a
                target="_blank"
                href="https://www.facebook.com/hulpiaarchitecten/"
              >
                <Icon src={facebook} />
              </a>
              <a
                target="_blank"
                href="https://www.instagram.com/hulpia.architecten/"
              >
                <Icon src={instagram} />
              </a>
            </SocialIcons>
          </RightSection>
        </SplitSection>
      </div>
    );
  }
}

export const pageQuery = graphql`
  query InfoPageQuery {
    allNavigationJson {
      edges {
        node {
          to
          name
          key
          sub
          subItems {
            to
            name
            key
          }
        }
      }
    }
  }
`;

export default InfoPage;



// WEBPACK FOOTER //
// ./src/pages/contact/info.js